
export const STOPBULLYING_SEND = 'STOPBULLYING_SEND';
export const STOPBULLYING_SEND_USER = 'STOPBULLYING_SEND_USER';
export const STOPBULLYING_SEND_CLASS = 'STOPBULLYING_SEND_CLASS';
export const STOPBULLYING_GET_ALL = 'STOPBULLYING_GET_ALL';
export const STOPBULLYING_DETAILS = 'STOPBULLYING_DETAILS';
export const STOPBULLYING_GET_USER = 'STOPBULLYING_GET_USER';
export const STOPBULLYING_READ = 'STOPBULLYING_READ'